import { RootStoreState } from '@/store';
import { ActionContext, Module } from 'vuex';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface AvailableServicesStoreState {
  availableServices:[];
}

export default {
  state:{
    availableServices:[],
  },
  mutations:{
  },
  actions:{
    async getAvailableServices(context: ActionContext<AvailableServicesStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'getapplications';
      return ApiServiceWrapper.get(endpoint);
    },
  },
  getters:{
    getAvailableServices(state) {
      return state.availableServices;
    },
  },
  namespaced: true,
} as Module<AvailableServicesStoreState, RootStoreState>;
